var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      staticClass: "minimal",
      class: [
        _vm.$options.filters.checkIfArchiveCategory(_vm.item, _vm.archiveCatId),
        { imgHover: _vm.type === "hover" },
        { "cat-item__sold-out": _vm.isArchive },
      ],
    },
    [
      _c(
        "div",
        { class: { itemHoverInfo: _vm.type === "hover" } },
        [
          _vm.type !== "hover"
            ? [
                _c("category-image-carousel", {
                  ref: "categoryImageCarousel",
                  attrs: {
                    "image-urls-data": _vm._f("itemImages")(
                      _vm.item.images,
                      _vm.imageUrlAccessor
                    ),
                    alt: _vm._f("itemName")(_vm.item),
                    title: _vm._f("itemName")(_vm.item),
                    "item-url": _vm._f("itemURL")(
                      _vm.item,
                      _vm.urlWithVariationId
                    ),
                    "enable-carousel":
                      _vm.$ceres.config.item.enableImageCarousel,
                    "disable-carousel-on-mobile": _vm.disableCarouselOnMobile,
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId),
              },
            },
            [
              _c("div", { staticClass: "cat-item__title" }, [
                _vm._v(_vm._s(_vm.texts.name2)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cat-item__desc" }, [
                _vm._v(_vm._s(_vm.texts.name3)),
              ]),
              _vm._v(" "),
              !_vm.isArchive
                ? _c(
                    "div",
                    { staticClass: "cat-item__price" },
                    [
                      _vm.item.item.itemType === "set"
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.itemSetPrice",
                                    { price: _vm.itemSetPrice }
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        : _vm.itemGraduatedPriceisCheapestSorting
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.itemFromPrice",
                                    { price: _vm.itemPriceGraduated }
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        : _vm.itemGraduatedPricesalableVariationCount
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.itemFromPrice",
                                    { price: _vm.itemPriceGraduated }
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("specialOffer")(
                                    _vm.item.prices.default.unitPrice.formatted,
                                    _vm.item.prices,
                                    "unitPrice",
                                    "formatted"
                                  )
                                ) +
                                "\n          "
                            ),
                          ],
                    ],
                    2
                  )
                : _c("div", { staticClass: "cat-item__sold-out-btn" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("HoferAntikschmuck::Template.notInStock")
                      )
                    ),
                  ]),
            ]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.type === "hover"
        ? [
            _c("category-image-carousel", {
              ref: "categoryImageCarousel",
              attrs: {
                "image-urls-data": _vm._f("itemImages")(
                  _vm.item.images,
                  _vm.imageUrlAccessor
                ),
                alt: _vm._f("itemName")(_vm.item),
                title: _vm._f("itemName")(_vm.item),
                "item-url": _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId),
                "enable-carousel": _vm.$ceres.config.item.enableImageCarousel,
                "disable-carousel-on-mobile": _vm.disableCarouselOnMobile,
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }